import { createElement } from 'react'
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  DownOutlined,
  EditOutlined,
  EnvironmentOutlined,
  ExclamationCircleOutlined,
  ExportOutlined,
  FileTextOutlined,
  PaperClipOutlined,
  ReadOutlined,
  TeamOutlined,
  TagOutlined,
  UploadOutlined,
  UpOutlined,
  UserOutlined,
  ContactsFilled,
  CheckSquareOutlined,
} from '@ant-design/icons'
import { ComponentController } from './component_controller'

interface AntIconProps {
  icon: string
  className: string
}

const IconMap = {
  check: CheckCircleOutlined,
  checkSquare: CheckSquareOutlined,
  close: CloseCircleOutlined,
  contacts: ContactsFilled,
  delete: DeleteOutlined,
  down: DownOutlined,
  edit: EditOutlined,
  exclamation: ExclamationCircleOutlined,
  export: ExportOutlined,
  file: FileTextOutlined,
  location: EnvironmentOutlined,
  paperclip: PaperClipOutlined,
  read: ReadOutlined,
  tag: TagOutlined,
  team: TeamOutlined,
  up: UpOutlined,
  upload: UploadOutlined,
  user: UserOutlined,
}

const AntIcon = (props: AntIconProps) => {
  const { icon, className } = props
  return createElement(IconMap[icon], {
    className: className,
  })
}

export class AntIconController extends ComponentController {
  get component() {
    return AntIcon
  }
}
